import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import RouteBuilder from './routeBuilder';
import InnerFrame from 'components/inner-frame/inner-frame';
import NHomePage from 'components/nhomepage/nhomepage.vue';

let chePiaoBuilder = new RouteBuilder('chepiao', ViewWrapper, InnerFrame);
let chePiaoRoutes = RouteBuilder.buildBasicInfo(chePiaoBuilder, null, NHomePage);
let financeInfo = RouteBuilder.buildFinanceInfo(chePiaoBuilder, true);
chePiaoRoutes.push(financeInfo);
import AcademyHome from 'views/academy/HomePage.vue';
let xgxy = RouteBuilder.buildXAXY(chePiaoBuilder, AcademyHome);
let gzzx = RouteBuilder.buildGZZX(chePiaoBuilder);

export default chePiaoRoutes.concat([xgxy, gzzx]);


// WEBPACK FOOTER //
// ./src/router/router.chepiao.js